import { useIsMobile } from "@outschool/ui-utils";
import React from "react";

type OnSend = () => void | Promise<unknown>;

export function useEnterToSend(onSend: OnSend) {
  const isMobile = useIsMobile();

  return React.useCallback(
    (event: React.KeyboardEvent) => {
      if (
        isMobile ||
        event.key !== "Enter" ||
        event.shiftKey ||
        event.nativeEvent.isComposing
      ) {
        return;
      }
      event.preventDefault();
      void onSend();
    },
    [isMobile, onSend],
  );
}
